module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual-process"
  }, [_c('h3', [_vm._v(_vm._s(_vm.produktnaam) + "verzekering")]), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('step1schademelden-component', {
    attrs: {
      "ctx": _vm.ctx,
      "schademeldenurl": _vm.schademeldenurl
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual-item"
  }, [_c('div', {
    staticClass: "hexagon-thick"
  }, [_c('p', {
    staticClass: "icon icon-archive clean"
  })]), _vm._v(" "), _c('h4', [_vm._v("In behandeling")]), _vm._v(" "), _c('p', [_vm._v("Wij nemen uw schademelding binnen 48 uur in behandeling.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#behandelingmodal"
    }
  }, [_vm._v("Lees meer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual-item"
  }, [_c('div', {
    staticClass: "hexagon-thick"
  }, [_c('p', {
    staticClass: "icon icon-user clean"
  })]), _vm._v(" "), _c('h4', [_vm._v("Beoordeling")]), _vm._v(" "), _c('p', [_vm._v("Uw schade wordt beoordeeld door een schade-expert, deze binnen 48 uur contact met u op.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#beoordelingmodal"
    }
  }, [_vm._v("Lees meer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visual-item"
  }, [_c('div', {
    staticClass: "hexagon-thick"
  }, [_c('p', {
    staticClass: "icon icon-check clean"
  })]), _vm._v(" "), _c('h4', [_vm._v("Afgehandeld")]), _vm._v(" "), _c('p', [_vm._v("Wij hebben uw dossier gesloten.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "behandelingmodal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("In behandeling")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Wij adviseren u, indien nog niet gekozen, gebruik te maken van onze herstelservice. Onze herstelservice is helaas niet voor alle schades in te zetten (bijv. niet voor televisies, sieraden, horloges, huishoudelijke apparaten, instrumenten).")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Kiest u voor onze herstelservice, dan schakelen wij CED Repair in. Zij maakt binnen 2 werkdagen telefonisch met u een afspraak. Voordelen van herstel via CED Repair is dat wij de schade rechtstreeks afrekenen met de hersteller en het standaard eigen risico vervalt.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Kiest u voor uw eigen hersteller of herstelt u de schade zelf of is de schade niet te herstellen, dan schakelen wij, afhankelijk van het schadebedrag een expert in of vragen de offerte/nota’s en eventuele aanvullende bewijsstukken bij u op.")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-modal-close",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("OK")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "beoordelingmodal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Beoordeling")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Na ontvangst van het expertiserapport of de offerte/nota’s/overige bewijsstukken wikkelen wij de schade met u af.")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-modal-close",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("OK")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e67ea66"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/schade/inboedel.vue
// module id = 78
// module chunks = 0